import {
    MatchOfTheDayMatchListActions,
    MatchOfTheDayMatchListSetFilterDataAction,
    MatchOfTheDayMatchListSetLoadingData,
    MatchOfTheDayMatchListStoreModel,
} from './match-of-the-day-match-list.constants';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { filterItemsSelectorFromRecords } from '../../utils/filter-items-from-records';
import applyUpdatesForMatchList from '../../utils/apply-updates-for-match-list';
import { getMatchOfTheDayMatchListSliceName } from './match-of-the-day-match-list.utils';
import { getPopularMatchListTotalRecords } from '../../utils/match-list-limit';
import { AggregatorOneOfTypeModel } from '@om-fe/models';
import { UpdateAction } from '@om-fe/api';
import { isBrowser } from '@om-fe/utils';

const initialState: MatchOfTheDayMatchListStoreModel = {
    fetchedFromBrowser: isBrowser(),
    ready: false,
    limit: 0,
    totalRecords: 0,
    isLoadingMoreData: false,
    isLoadingData: true,
    discipline: undefined,
    filteredEventInfos: {},
    filteredMainMarketsList: [],
    filteredMainMarkets: {},
    filteredMarketGroupsOverviewList: [],
    filteredMarketGroupsOverview: {},
    filteredEventStatistics: [],
    filteredMarketAndOutcomeRelation: {},
    filteredOutcomes: {},
    filteredBettingOffers: {},
    filteredMatchesWithEvents: {},
    filteredMatchesIds: [],
    marketsWithOutcomesAndBettingOffers: {},
    filteredStreamingProviderEventRelation: {},
};

export const matchOfTheDayMatchListGroupsOverviewReducerCreator = (instanceId: string) => (
    state: MatchOfTheDayMatchListStoreModel = initialState,
    action: AppAction,
): MatchOfTheDayMatchListStoreModel => {
    const slice: string = getMatchOfTheDayMatchListSliceName(instanceId);
    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case MatchOfTheDayMatchListActions.SetLoadingData: {
            const { payload: { isLoadingMoreData } } = action as MatchOfTheDayMatchListSetLoadingData;

            return {
                ...state,
                isLoadingData: !isLoadingMoreData,
                isLoadingMoreData,
            };
        }
        case MatchOfTheDayMatchListActions.SetFilterData: {
            const { payload } = action as MatchOfTheDayMatchListSetFilterDataAction;

            return {
                ...state,
                limit: payload.limit,
                disciplineId: payload.disciplineId,
                marketGroupsOverviewIds: payload.marketGroupsOverviewIds,
                locationId: payload.locationId,
                eventCategoryId: payload.eventCategoryId,
                liveStatus: payload.liveStatus,
                dateRange: payload.dateRange,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;
            const records: AggregatorOneOfTypeModel[] = payload.records;
            const totalRecords: number = getPopularMatchListTotalRecords(payload.records);
            
            return {
                ...state,
                ...filterItemsSelectorFromRecords(records),
                fetchedFromBrowser: isBrowser(),
                totalRecords,
                ready: true,
                isLoadingData: false,
                isLoadingMoreData: false,
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;
            const totalRecords: number = getPopularMatchListTotalRecords(payload.records);

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
                totalRecords,
                isLoadingMoreData: false,
            };
        }
        default:
            return state;
    }
};